import { useMeasurementSignals } from '../../StateManagment/MeasurementSignalsContext'
import { MOMENT_STATUS_LABELS, MOMENT_STATUS_MARKS } from '../../helpers/measurementSignals/describeSignal'

// AI-CONTEXT: See docs/features/meetmoment-signalering.md

/**
 * De meetmomenten van één onderzoek voor één deelnemer of huishouden, met per
 * meetmoment of het is ingevuld.
 *
 * Vier waarden: ingevuld, nog niet ingevuld, niet meer mogelijk, en niet te
 * zeggen. Die laatste twee zijn allebei nodig. Bij een anoniem onderzoek weten
 * we niet wie wat invulde, en dat als "nog niet ingevuld" tonen is een onware
 * bewering. En een nulmeting van iemand die al meedraaide toen het meetmoment
 * werd aangemaakt is geen achterstand maar een gepasseerd station.
 *
 * Vereist een `MeasurementSignalsProvider` boven zich. Zonder provider blijft
 * `loaded` false en toont dit component "Laden…" in plaats van een lege staat —
 * dat is de veilige kant om op te vallen.
 *
 * @param {object} props
 * @param {string} props.entityId - Personas.ID of Adresses.ID
 * @param {string} props.researchId - Research.ID
 * @param {object} [props.row] - De al gevonden signaalrij. Geef die mee als de ouder hem
 *   toch al heeft; dan hoeft dit component niet opnieuw door alle rijen te zoeken.
 */
const MomentStatusChips = ({ entityId, researchId, row: givenRow }) => {
    const { rows, loaded, unavailable } = useMeasurementSignals()

    if (!loaded) return <span className='measurement-signal-note'>Laden…</span>

    if (unavailable.length > 0) {
        return <span className='measurement-signal-note measurement-signal-note--warning'>Niet op te halen</span>
    }

    const row = givenRow
        || rows.find((entry) => entry.entityId === entityId && entry.researchId === researchId)

    if (!row) return <span className='measurement-signal-note'>Geen meetmomenten</span>

    return (
        <span className='measurement-chips'>
            {row.moments.map((moment) => (
                <span
                    key={moment.ID}
                    className={[
                        'measurement-chip',
                        `measurement-chip--${moment.status}`,
                        row.next?.ID === moment.ID ? 'measurement-chip--next' : '',
                    ].filter(Boolean).join(' ')}
                    title={`${moment.Title || 'Meetmoment'}: ${MOMENT_STATUS_LABELS[moment.status]}`}
                >
                    <span className='measurement-chip-mark'>{MOMENT_STATUS_MARKS[moment.status]}</span>
                    {moment.Title || 'Meetmoment'}
                </span>
            ))}
        </span>
    )
}

export default MomentStatusChips
